import { createSlice } from '@reduxjs/toolkit';
import { revertAll } from '../actions';
import { IDashboardMetrics, IDashboardEarnings } from '../../interfaces/dashboard-interface';

export interface IHeaterState {
    is_refresh: boolean;
    is_metrics_api_called: boolean;
    metricsData: IDashboardMetrics;
    earningsData: IDashboardEarnings;
    cachedData: any;
}

const initialState: IHeaterState = {
    is_refresh: false,
    is_metrics_api_called: false,
    metricsData: {
        power_sensor_timestamp: null,
        water_sensor_timestamp: null,
        avg_gpu_util_7d: 0,
        avg_gpu_util_30d: 0,
        power_usage: null,
        water_temperature: null,
        temperature_history: [],
        internet: null,
        power: null,
        machine_id: '',
    },
    earningsData: {
        gpu_earning_month: 0,
        storage_earning_month: 0,
        gpu_earning_total: 0,
        storage_earning_total: 0,
        machine_name: '',
        gpu_earnings_updated_at: null,
    },
    cachedData: null,
};

const heaterSlice = createSlice({
    name: 'heater',
    initialState,
    reducers: {
        setIsRefresh: (state, action) => {
            return {
                ...state,
                is_refresh: action.payload,
            };
        },
        setIsMetricsAPICalled: (state, action) => {
            return {
                ...state,
                is_metrics_api_called: action.payload,
            };
        },
        setMetricsData: (state, action) => {
            return {
                ...state,
                metricsData: {
                    ...state.metricsData,
                    ...action.payload,
                },
            };
        },
        setEarningsData: (state, action) => {
            return {
                ...state,
                earningsData: {
                    ...state.earningsData,
                    ...action.payload,
                },
            };
        },
        setCachedMetricsData: (state, action) => {
            return {
                ...state,
                cachedData: {
                    ...state.cachedData,
                    ...action.payload,
                },
            };
        },
    },
    extraReducers: builder => builder.addCase(revertAll, () => initialState),
});

export const { setMetricsData, setIsMetricsAPICalled, setEarningsData, setIsRefresh, setCachedMetricsData } =
    heaterSlice.actions;

export const heaterReducer = heaterSlice.reducer;
